import { createReducer, on } from '@ngrx/store';
import * as AppActions from '../app.actions';
import * as ConfigEditorActions from '../config-editor-screen/config-editor-screen.actions';
import * as ContentGroupEditScreenActions from '../content-group-edit-screen/content-group-edit-screen.actions';
import * as ContentGroupListScreenActions from '../content-group-list-screen/content-group-list-screen.actions';
import * as TenantIndependentContentGroupListScreenActions from '../tenant-independent-content-group/tenant-independent-content-group.actions';
import * as ContentGroupSelectorActions from '../content-group/content-group.actions';
import * as ProgramAutocompleteActions from '../create-tray-screen/components/program-autocomplete/program-autocomplete.actions';
import * as TrayEditorActions from '../create-tray-screen/create-tray-screen.actions';
import * as FileUploadActions from '../file-upload/file-upload.actions';
import * as MenuEditorActions from '../menu-editor/menu-editor.actions';
import * as ChannelListActions from '../channel-list/channel-list.actions';
import * as PageEditScreenActions from '../page-edit-screen/page-edit-screen.actions';
import * as PageScreenActions from '../page-screen/page-screen.actions';
import * as PageSelectorActions from '../shared/modules/page-selector/page-selector.actions';
import * as RedirectPoliciesActions from '../redirect-policies/redirect-policies.actions';
import { NotificationColor } from './components/notification.view-model';
import * as TenantIndependentContentGroupEditScreenActions from '../tenant-independent-content-group/components/tenant-independent-content-group-edit-screen/tenant-independent-content-group-edit-screen.actions';
import * as Actions from './notification.actions';

export const featureKey = 'cxbNotification';

export interface FeatureState {
  message: string;
  color: NotificationColor;
}

export interface AppState {
  [featureKey]: FeatureState;
}

export const initialState: FeatureState = {
  message: undefined,
  color: undefined,
};

export const reducer = createReducer(
  initialState,
  on(Actions.setCxbNotification, (state, action): FeatureState => ({ ...state, message: action.message, color: action.color })),
  // actions related to failure events
  on(
    AppActions.loadCxbUserSegmentsFail,

    PageScreenActions.loadCxbPageScreenFail,
    PageScreenActions.createCxbPageFail,

    PageEditScreenActions.loadCxbPageEditScreen.failAction,
    PageEditScreenActions.unpublishCxbPage.failAction,
    PageEditScreenActions.updateCxbPageVersion.failAction,

    PageEditScreenActions.createCxbPageDraft.failAction,
    PageEditScreenActions.publishCxbPageDraft.failAction,
    PageEditScreenActions.deleteCxbPageDraft.failAction,

    PageEditScreenActions.updateCxbPageItems.failAction,
    PageEditScreenActions.cloneCxbPageItem.failAction,
    PageEditScreenActions.deleteCxbPageItem.failAction,

    MenuEditorActions.loadCxbMenuEditorPageFail,
    MenuEditorActions.publishCxbMenuEditorPageFail,

    TrayEditorActions.createCxbPageItemFail,
    TrayEditorActions.loadCxbPageItemFail,
    TrayEditorActions.updateCxbPageItemFail,
    TrayEditorActions.deleteCxbPageItemFail,

    ProgramAutocompleteActions.programAutocompleteByIdFail,
    ProgramAutocompleteActions.programAutocompleteQueryFail,
    FileUploadActions.uploadCxBFileFail,
    ContentGroupSelectorActions.fetchFeedFail,
    PageSelectorActions.fetchPagesFail,

    ContentGroupEditScreenActions.deleteCxbContentGroupFail,
    ContentGroupEditScreenActions.fetchContentGroupFail,
    ContentGroupEditScreenActions.loadCxbContentGroupPreviewFail,
    ContentGroupEditScreenActions.searchCxbProgramsFail,
    ContentGroupEditScreenActions.updateCxbContentGroupMetaFail,
    ContentGroupEditScreenActions.updateCxbContentGroupFail,

    ContentGroupListScreenActions.createContentGroupFail,
    ContentGroupListScreenActions.loadScreenFail,

    TenantIndependentContentGroupListScreenActions.loadScreenFail,

    TenantIndependentContentGroupEditScreenActions.fetchContentGroupFail,

    ConfigEditorActions.loadCxbConfigEntriesFail,
    ConfigEditorActions.loadCxbConfigEntryFail,
    ConfigEditorActions.createCxbConfigEntryFail,
    ConfigEditorActions.updateCxbConfigEntryFail,
    ConfigEditorActions.deleteCxbConfigEntryFail,
    ChannelListActions.fetchChannelsFail,
    ChannelListActions.syncChannelsFail,

    RedirectPoliciesActions.fetchRedirectPolicies.failAction,
    RedirectPoliciesActions.updateRedirectPolicy.failAction,
    RedirectPoliciesActions.createRedirectPolicy.failAction,
    RedirectPoliciesActions.deleteRedirectPolicy.failAction,

    (state, action): FeatureState => ({
      ...state,
      message: action.errorMessage,
      color: NotificationColor.RED,
    })
  ),
  on(
    Actions.setCxbSuccessNotification,
    (state, action): FeatureState => ({
      ...state,
      message: action.message,
      color: NotificationColor.GREEN,
    })
  ),
  on(
    Actions.setCxbErrorNotification,
    (state, action): FeatureState => ({
      ...state,
      message: action.message,
      color: NotificationColor.RED,
    })
  )
);
